'use client';

import Image from '@/components/Image';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import React, { useContext } from 'react';
import { useTranslations } from '@/i18n/use-translations';
interface BlogNoArticleProps {
  className?: string;
}

const BlogNoArticle: React.FC<BlogNoArticleProps> = ({ className = '' }) => {
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;
  const t = useTranslations('blog.components');
  return (
    <div className={`blog-no-article my-[67px] flex flex-col items-center ${className}`}>
      {/* 无文章图片 */}
      <Image
        src="/blog/oops.png"
        alt="no articles"
        width={113}
        height={113}
        className={`blog-no-article-image mb-8 ${isWeb ? 'w-[137px]' : 'w-[113px]'}`}
      />

      {/* Oops标题 */}
      <h2
        className={`blog-no-article-oops font-bb text-primary-text  ${isWeb ? 'text-[18px] mb-12 leading-[18px]' : 'text-[14px] mb-8 leading-14'}`}
      >
        {t('oops')}
      </h2>

      {/* 描述文字 */}
      <p
        className={`blog-no-article-description  text-12 font-normal text-secondary-text leading-[19px] text-center ${isWeb ? 'w-[454px]' : 'w-[272px]'}`}
      >
        {t('noArticlesBrowseOtherCategory')}
      </p>
    </div>
  );
};

export default BlogNoArticle;
